import { useState } from "react";

import UniversalModal from "../UniversalModal/UniversalModal";
import UserHistoryModalContent from "../UserHistory/UserHistoryModalContent/UserHistoryModalContent";

import styles from "./UserHistoryButton.module.css";

const UserHistoryButton = ({ isDisabled, handleShow, userHistory }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShowModal = () => {
    handleShow();
    setShowModal(true);
  };

  return (
    <>
      <button
        type="block"
        disabled={isDisabled}
        className={styles["history-btn"]}
        onClick={handleShowModal}
      >
        История
      </button>
      <UniversalModal
        showModal={showModal}
        handleClose={handleClose}
        title="История редактирования"
        bodyContent={<UserHistoryModalContent userHistory={userHistory} />}
      />
    </>
  );
};

export default UserHistoryButton;
